// extracted by mini-css-extract-plugin
export default {"container":"OperableImage_container__deYv0","uploadArea":"OperableImage_uploadArea__2XQUv"};